import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Accordion from '../../accordion/accordion';
import TimeCounter from '../../time-counter/time-counter';
import routes from '../../../utils/routes';
import InternalPageTypes from '../internal-page-types';

const mapStateToProps = ({ App }) => ({
    studiedSeconds: Object.values(App.student)
        .reduce((acc, enrollments) => acc + videosTimeSpent(enrollments.videos), 0),
    classes: App.classes
        .map(c => buildClassesSections(c, App.classesNewEad)),
});

const Wrapper = ({ classes, studiedSeconds, pageType, ...props }) => {
    const items = classes.map((aClass) => {
        const subItems = aClass.items.map(session => {
            return (
                <AccordionSubItem {...session} key={session.id}/>
            );
        });
        return { ...aClass, value: aClass.title, items: subItems };
    });

    const isClassOrCourse = pageType === InternalPageTypes.CLASS_RESOURCE || pageType === InternalPageTypes.COURSE_RESOURCE;
    return (
        <div className='app-body'>
            <div className='accordion'>
                <Accordion sections={items}/>
            </div>
            <div className='content-wrapper'>
                {props.children}
            </div>
            <div className='left-side-container'>
                {!isClassOrCourse &&
                    <div style={{ display: 'none' }} className='time-counter'>
                        <TimeCounter duration={studiedSeconds} title='Tempo de vídeo assistido'/>
                    </div>
                }
            </div>
        </div>
    );
};

export default connect(mapStateToProps)(Wrapper);

const AccordionSubItem = ({ link, title, expired }) => {
    if (link === 'redirect') {
        return (
            <button type='buttom' className='accordion-buttom' onClick={()=>window.open('https://online-tests.ead.febracis.com.br.dev.fortalsistemas.com.br/')}>
                {title}
            </button>
        );
    }
    return (
        <Link to={link} onClick={e => expired && e.preventDefault()} className={expired ? 'disabled-link' : ''}>
            <div className='accordion-item'>{title}</div>
        </Link>
    );
};

const videosTimeSpent = videos => videos ? Object.values(videos).reduce((acc, v) => acc + v.secondsSpent, 0) : 0;

const buildClassesSections = ({ className, cards = [], classId }, classesNewEad = []) => {
    const currentNewClasses = classesNewEad.find(e=>e.class_id === classId);
    let renderItems = [];
    for (const card of cards) {
        if ((card.id === 'online-test' && (currentNewClasses && currentNewClasses.tests.length === 0))) {
            continue;
        }
        renderItems.push({
            title: card.title,
            cardId: card.id,
            classId: classId,
            link: routes.RESOURCES(classId, card.id),
            expired: card.expired,
        });
    }
    return {
        title: className,
        classId: classId,
        items: renderItems,
    };
};



// WEBPACK FOOTER //
// ./src/components/internal-pages/components/pages-wrapper.js